export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-folder-add-d902e7ef64b42c26067d5b2b1c736bd7.svg";